import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import Flex from '@magalu/stereo-ui/atoms/Flex';
import { getBackgroundColor } from '@magalu/stereo-ui-styles/build/utils';
export var Section = styled(Flex)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 289px;\n  border-radius: 8px;\n  background: ", ";\n  align-items: center;\n  flex-direction: row;\n"])), function (props) {
  return getBackgroundColor('white')(props);
});